import { WELCOME_TOUR_SINCE } from "./tours";
import type { TourId } from "./types";

export type EligibilityInput = {
  tourId: TourId;
  seen: ReadonlySet<TourId>;
  activeTourId: TourId | null;
  user: { id: string; createdAt?: string; role?: string; userType?: string } | null;
  owesOnboarding: boolean;
  /** Admin viewing as / impersonating a user: never show them tours. */
  isAdminViewing: boolean;
  /** Sidebar in drawer mode (max-width:1000px): nav anchors don't exist. */
  isNarrow: boolean;
  account: { kind: "individual" | "team" | "developer"; teamOwnerUserId?: string };
};

const STAFF_USER_TYPES = new Set(["admin", "organization", "api"]);

/** Whether `tourId` may auto-start right now. Replay (force) bypasses this. */
export const isTourEligible = (i: EligibilityInput): boolean => {
  const { user } = i;
  if (!user || i.seen.has(i.tourId) || i.activeTourId) return false;
  if (i.owesOnboarding || i.isAdminViewing || i.isNarrow) return false;

  switch (i.tourId) {
    case "welcome":
      return (
        i.account.kind === "individual" &&
        user.role !== "admin" &&
        !STAFF_USER_TYPES.has(user.userType ?? "") &&
        !!user.createdAt &&
        Date.parse(user.createdAt) >= Date.parse(WELCOME_TOUR_SINCE)
      );
    case "team":
      return i.account.kind === "team" && i.account.teamOwnerUserId === user.id;
    case "developer":
      return i.account.kind === "developer";
    case "session":
      return true;
  }
};
